var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectedLocationMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 42,
    viewBox: "0 0 32 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4271_82253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7379 38.5268C15.2364 39.6533 16.7637 39.6515 17.2666 38.5321C17.4975 38.018 17.7243 37.4913 17.9495 36.9681C18.5332 35.6124 19.1066 34.2805 19.7154 33.2553C20.5081 31.9205 21.4764 30.6879 22.5027 29.4727C22.8714 29.0361 23.2509 28.598 23.632 28.1581C24.3001 27.3869 24.9733 26.6098 25.6026 25.8242C27.5956 23.336 29.2824 20.6057 29.4788 17.0274C29.6857 13.2586 28.3772 9.4154 25.5494 6.53214C20.2765 1.15595 11.7235 1.15595 6.45064 6.53215C3.62282 9.4154 2.31433 13.2586 2.52119 17.0274C2.71977 20.6455 4.43316 23.356 6.44592 25.8243C7.0425 26.556 7.68188 27.2851 8.31696 28.0094C8.7399 28.4917 9.16094 28.9719 9.56615 29.4491C10.5951 30.661 11.5614 31.8975 12.3444 33.2505C12.9283 34.2592 13.4759 35.5588 14.0341 36.8834C14.2658 37.4332 14.4993 37.9874 14.7379 38.5268Z",
    fill: "#BF200B",
    stroke: "white",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0003 11.3333C15.2639 11.3333 14.667 11.9303 14.667 12.6667C14.667 13.403 15.2639 14 16.0003 14C16.7367 14 17.3337 13.403 17.3337 12.6667C17.3337 11.9303 16.7367 11.3333 16.0003 11.3333ZM13.3337 12.6667C13.3337 11.1939 14.5276 10 16.0003 10C17.4731 10 18.667 11.1939 18.667 12.6667C18.667 14.1394 17.4731 15.3333 16.0003 15.3333C14.5276 15.3333 13.3337 14.1394 13.3337 12.6667ZM11.3337 14C10.9655 14 10.667 14.2985 10.667 14.6667C10.667 15.0349 10.9655 15.3333 11.3337 15.3333C11.7018 15.3333 12.0003 15.0349 12.0003 14.6667C12.0003 14.2985 11.7018 14 11.3337 14ZM9.33366 14.6667C9.33366 13.5621 10.2291 12.6667 11.3337 12.6667C12.4382 12.6667 13.3337 13.5621 13.3337 14.6667C13.3337 15.7712 12.4382 16.6667 11.3337 16.6667C10.2291 16.6667 9.33366 15.7712 9.33366 14.6667ZM20.667 14C20.2988 14 20.0003 14.2985 20.0003 14.6667C20.0003 15.0349 20.2988 15.3333 20.667 15.3333C21.0352 15.3333 21.3337 15.0349 21.3337 14.6667C21.3337 14.2985 21.0352 14 20.667 14ZM18.667 14.6667C18.667 13.5621 19.5624 12.6667 20.667 12.6667C21.7716 12.6667 22.667 13.5621 22.667 14.6667C22.667 15.7712 21.7716 16.6667 20.667 16.6667C19.5624 16.6667 18.667 15.7712 18.667 14.6667ZM16.0003 17.3333C14.8786 17.3333 13.9171 18.0261 13.5234 19.0097C13.4012 19.315 13.3337 19.6488 13.3337 20V20.6667H18.667V20C18.667 19.6488 18.5994 19.315 18.4772 19.0097C18.0836 18.0261 17.122 17.3333 16.0003 17.3333ZM20.0003 20.6667H22.0003V20C22.0003 19.2636 21.4034 18.6667 20.667 18.6667C20.3629 18.6667 20.0828 18.768 19.8581 18.9398C19.9509 19.278 20.0003 19.6336 20.0003 20V20.6667ZM19.2861 17.7184C18.564 16.6804 17.3621 16 16.0003 16C14.6385 16 13.4367 16.6804 12.7146 17.7184C12.3119 17.4743 11.8392 17.3333 11.3337 17.3333C9.8609 17.3333 8.66699 18.5272 8.66699 20V21.3333C8.66699 21.7015 8.96547 22 9.33366 22H22.667C23.0352 22 23.3337 21.7015 23.3337 21.3333V20C23.3337 18.5272 22.1398 17.3333 20.667 17.3333C20.1615 17.3333 19.6887 17.4743 19.2861 17.7184ZM12.1425 18.9398C11.9179 18.768 11.6377 18.6667 11.3337 18.6667C10.5973 18.6667 10.0003 19.2636 10.0003 20V20.6667H12.0003V20C12.0003 19.6336 12.0498 19.278 12.1425 18.9398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4271_82253",
    x: 0,
    y: 0,
    width: 32,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.0509804 0 0 0 0 0.141176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4271_82253"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00784314 0 0 0 0 0.0509804 0 0 0 0 0.141176 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4271_82253",
    result: "effect2_dropShadow_4271_82253"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4271_82253",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedLocationMarker);
export default __webpack_public_path__ + "static/media/selected-location-marker.226ce805c121bf36a678a0abce5e1889.svg";
export { ForwardRef as ReactComponent };